import { Mode } from "@/modes/mode";
import { changeMode } from "@/store/mode-slice";
import { resetSheetToSheetAlignment } from "@/store/modes/sheet-to-sheet-alignment-mode-slice";
import { SheetToSheetAlignmentModeOverlay } from "./sheet-to-sheet-alignment-mode-overlay";
import { SheetToSheetAlignmentModeScene } from "./sheet-to-sheet-alignment-mode-scene";

export const sheetToSheetAlignmentMode: Mode = {
  name: "sheetToSheetAlignment",
  ModeScene: SheetToSheetAlignmentModeScene,
  ModeOverlay: SheetToSheetAlignmentModeOverlay,
  hasCustomCanvasStyle: true,
  exclusive: {
    title: "Align sheet to sheet",
    onBack({ dispatch }) {
      dispatch(resetSheetToSheetAlignment());
      dispatch(changeMode("start"));

      return Promise.resolve();
    },
  },
};
